"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyFromPath;

var _hdkdEd = _interopRequireDefault(require("./hdkdEd25519"));

var _hdkdSr = _interopRequireDefault(require("./hdkdSr25519"));

var _hdkdEcdsa = _interopRequireDefault(require("./hdkdEcdsa"));

// Copyright 2017-2020 @polkadot/util-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const generators = {
  ecdsa: _hdkdEcdsa.default,
  ed25519: _hdkdEd.default,
  // FIXME This is Substrate-compatible, not Ethereum-compatible
  ethereum: _hdkdEcdsa.default,
  sr25519: _hdkdSr.default
};

function keyFromPath(pair, path, type) {
  const keyHdkd = generators[type];
  return path.reduce((pair, junction) => {
    return keyHdkd(pair, junction);
  }, pair);
}